import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "sectionbody" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "menubarMargin" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackgroundCanvas = _resolveComponent("BackgroundCanvas")!
  const _component_MenuBar = _resolveComponent("MenuBar")!
  const _component_IKEP = _resolveComponent("IKEP")!
  const _component_NotFound = _resolveComponent("NotFound")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_PageBottom = _resolveComponent("PageBottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BackgroundCanvas, { isBackgroundMove: _ctx.isBackgroundMove }, null, 8, ["isBackgroundMove"]),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_MenuBar, { isBackgroundMove: _ctx.isBackgroundMove }, null, 8, ["isBackgroundMove"]),
      _hoisted_2,
      _withDirectives(_createVNode(_component_IKEP, { isLogoMove: _ctx.isBackgroundMove }, null, 8, ["isLogoMove"]), [
        [_vShow, _ctx.isIndexPage]
      ]),
      (_ctx.isNotFound)
        ? (_openBlock(), _createBlock(_component_NotFound, { key: 0 }))
        : (_openBlock(), _createBlock(_component_router_view, {
            key: 1,
            isBackgroundMove: _ctx.isBackgroundMove
          }, null, 8, ["isBackgroundMove"])),
      _createVNode(_component_PageBottom)
    ])
  ], 64))
}